module.exports = __webpack_public_path__ + "static/media/check.f7833248.svg";